import { render } from "./EnrolmentRow.vue?vue&type=template&id=19180a7d"
import script from "./EnrolmentRow.vue?vue&type=script&lang=ts"
export * from "./EnrolmentRow.vue?vue&type=script&lang=ts"
script.render = render

export default script